import React from 'react';

/**
 * @author 이현우
 * @returns
 */
const UntactStep3 = () => {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.5648 4.28751C23.6248 4.54099 23.6573 4.80189 23.6573 5.06864C23.6573 7.12155 21.9863 8.7926 19.9334 8.7926C19.5067 8.7926 19.0942 8.70941 18.7048 8.56878L18.2942 8.42051L17.9854 8.72906L4.12795 22.5743L2.42793 20.8743L11.2815 12.0207L11.7676 11.5346L11.2815 11.0484L9.03794 8.8049L8.5518 8.31876L8.06567 8.8049L7.65691 9.21366L6.36586 7.92261L5.19222 6.74897V6.76157L4.1673 5.73666L8.14274 1.76122C8.14283 1.76114 8.14292 1.76105 8.143 1.76096C8.14302 1.76095 8.14303 1.76093 8.14304 1.76092C8.72309 1.18175 9.50929 0.856445 10.329 0.856445C10.9155 0.856445 11.4848 1.02297 11.9737 1.32985L9.84285 3.46073L9.35672 3.94687L9.84286 4.433L11.1339 5.72406L10.7251 6.13282L10.239 6.61895L10.7251 7.10509L12.9687 9.34863L13.4548 9.83476L13.941 9.34863L16.2727 7.01686L16.5816 6.70802L16.4332 6.29722C16.2926 5.90777 16.2094 5.49528 16.2094 5.06864C16.2094 3.01573 17.8805 1.34468 19.9334 1.34468C20.2001 1.34468 20.461 1.37722 20.7145 1.43722L18.0608 4.09094L17.5746 4.57708L18.0608 5.06321L19.9388 6.94123L20.4249 7.42737L20.9111 6.94123L23.5648 4.28751ZM5.19222 11.6909L4.98482 11.8983L1.49522 8.40874L1.70262 8.20135H4.97222H5.19222V8.40874V11.6909ZM16.2207 15.999L17.9217 14.2979L24.5069 20.8831L22.8059 22.5842L16.2207 15.999Z"
        stroke="white"
        strokeWidth="1.375"
      />
    </svg>
  );
};

export default UntactStep3;
